import $axios from "@/helpers/axios-helper";
import { service_names } from "@/constants/Services";

const state = () => ({
  scId: "",
  school: null,
  isVerifiedOTP: false
});

const getters = {
  isAuthenticated: state => state.scId && state.isVerifiedOTP,
  getScId: state => state.scId,
  getSchool: state => state.school,
  allowedDomain: state => (state.school && state.school.allowed_domain) || ""
};

const actions = {
  async FetchUserSchools() {
    try {
      const res = await $axios.get(`${service_names.school}/schools/my-schools`);
      return res;
    } catch (error) {
      throw error;
    }
  },

  async VerifyScId({ commit }, scId) {
    try {
      const path = `${service_names.school}/schools/code/${scId}`;
      const res = await $axios.get(path);

      if (res) {
        commit("setScId", scId);

        // keep allowed_domain up to date with the school record
        const school = (res && res.data) || res;
        if (school && school.allowed_domain) {
          commit("setSchool", school);
        }

        // return true;
        return res;
      }
    } catch (error) {
      throw error;
    }
  },

  SetSchool({ commit }, school) {
    commit("setSchool", school);
  },

  async VerifyOTP({ commit }, otpCode) {
    const path = `${service_names.utility}/otp/${otpCode}`;
    await $axios.get(path);
    commit("verifiedOTP");
    return true;
  },

  Logout({ commit }) {
    commit("clearSchoolAuth");
  },

  byPassOTP({ commit }) {
    commit("verifiedOTP");
  }
};

const mutations = {
  setScId(state, scId) {
    state.scId = scId;
  },

  setSchool(state, school) {
    state.school = school || null;
  },

  verifiedOTP(state) {
    state.isVerifiedOTP = true;
  },

  // clearVerifiedOTP(state) {
  //   state.isVerifiedOTP = false;
  // },

  clearSchoolAuth(state) {
    // remain saved school_id
    state.isVerifiedOTP = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
